'use client';

import { memo } from 'react';
import { ScEmblaArrows } from './styled';

interface IEmblaArrowsProps {
  canScrollPrev: boolean;
  canScrollNext: boolean;
  onPrev: () => void;
  onNext: () => void;
}

export const EmblaArrows = memo(
  ({ canScrollPrev, canScrollNext, onPrev, onNext }: IEmblaArrowsProps) => (
    <ScEmblaArrows>
      <button
        aria-label="Previous slide"
        className="embla__arrow prev"
        disabled={!canScrollPrev}
        onClick={onPrev}
        type="button"
      />
      <button
        aria-label="Next slide"
        className="embla__arrow next"
        disabled={!canScrollNext}
        onClick={onNext}
        type="button"
      />
    </ScEmblaArrows>
  )
);
